import React, { useEffect, useState } from 'react';
import './ContentSidebarUser.css';

const SidebarShimmer = () => (
    <div className="sidebar-shimmer-wrapper">
        {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="sidebar-shimmer-item">
                <div className="sidebar-shimmer-icon" />
                <div className="sidebar-shimmer-lines">
                    <div className="sidebar-shimmer-line sidebar-shimmer-line--long" />
                    <div className="sidebar-shimmer-line sidebar-shimmer-line--short" />
                </div>
            </div>
        ))}
    </div>
);

const ContentSidebar = ({
    items,
    sidebarLoading,
    setSelectedRecord,
    renderActionButton,
    selectedRecord,
    onChange
}) => {
    const conditionItem = selectedRecord?.courseContentId || selectedRecord?.contentId || null;
    const [activeItemId, setActiveItemId] = useState(conditionItem);

    const getResourceType = (link) => {
        if (!link) return "default";
        const lower = link.toLowerCase();
        if (lower.includes("youtube.com") || lower.includes("youtu.be")) return "youtube";
        if (lower.endsWith(".mp4") || lower.endsWith(".mov")) return "video";
        if (lower.endsWith(".pdf")) return "pdf";
        if (lower.startsWith("http://") || lower.startsWith("https://")) return "website";
        return "default";
    };

    const handleItemClick = (item) => {

        if(!item.acknowledged) return;
        const idToSet = item.courseContentId || item.contentId;
        if(!idToSet) return;
        setActiveItemId(idToSet);
        setSelectedRecord(item);
        
        if (renderActionButton) renderActionButton(item)();

        if (onChange) {
            onChange(idToSet);
        }
    };

    useEffect(() => {
        if (selectedRecord) {
            setActiveItemId(selectedRecord.courseContentId || selectedRecord.contentId);
        }
    }, [selectedRecord]);

    if (sidebarLoading) {
        return <SidebarShimmer />;
    }

    return (
        <div className="content-sidebar-items-container">
            <div className="content-sidebar-items-wrapper">
                {items && items.length > 0 ? (
                    [...items].reverse().map((item) => {
                        const resourceType = getResourceType(item.resourceLink);
                        const isActive = 
                            activeItemId === item.courseContentId || 
                            activeItemId === item.contentId;
                        const isAcknowledged = item.acknowledged

                        return (
                            <div
                                key={item.courseContentId || item.contentId || Math.random()}
                                className={isActive ? "content-sidebar-item-active" : "content-sidebar-item"}
                                data-type={resourceType}
                                onClick={() => handleItemClick(item)}
                                style={{
                                    position: 'relative',
                                    transition: 'all 0.3s ease',
                                    cursor: isAcknowledged ? "pointer" : "auto"
                                }}
                            >
                                <div className="content-sidebar-text">
                                    {item.title}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="content-sidebar-empty">
                        No content available
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContentSidebar;  